import { AxiosResponse } from "axios";
import api from "./client";

// List requests & complaints (shared endpoint)
export const getSubmissions = (
  tenant_id: string,
  params?: Record<string, unknown>,
): Promise<AxiosResponse> =>
  api.get("/consent-request-submission", {
    params: { tenant_id, ...params },
  });

// Create complaint or request
export const createSubmission = (
  tenant_id: string,
  purpose_id: string,
  payload: unknown,
): Promise<AxiosResponse> =>
  api.post("/consent-request-submission", payload, {
    params: { tenant_id, purpose_id },
  });

// My Requests (per company) — kept for backward compat if needed
export const getMyRequests = (
  companyId: string,
  params?: Record<string, unknown>,
): Promise<AxiosResponse> => api.get(`/companies/${companyId}/requests`, { params });

// My Complaints (top-level) — kept for backward compat if needed
export const getMyComplaints = (params?: Record<string, unknown>): Promise<AxiosResponse> =>
  api.get("/complaints", { params });
